import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { newPlaceZoneBooking } from "../../../utils/axios-requests";
import { BookingStrategyContext } from "./bookingStrategies";
import { buildUsers } from "./buildUsers.function";

export const placeZoneStrategy = (ctx: BookingStrategyContext) => {
  const users = buildUsers(ctx);

  ctx.handlePromise(
    newPlaceZoneBooking({
      users,
      startDate: ctx.inputs.bookingFrom,
      endDate: ctx.inputs.bookingTo,
      startTime: "00:01",
      endTime: "23:59",
      weekdays: ctx.inputs.weekdays,
      bookingType: ctx.inputs.bookingType as BookingType,
      locationInventoryId: ctx.inputs.selectedLocation,
      zoneBookingUsers: ctx.inputs.zoneAccess ?? [],
      zoneBookingObject: ctx.inputs.restrictionObject.object.zoneBookingObject,
      zoneBookingObjectType: ctx.inputs.restrictionObject.object.type,
      zoneBookingObjectClient: ctx.inputs.restrictionObject.company.id,
      ...ctx.standardBookingInfo
    }),
    ctx.onSuccess,
    ctx.onError
  );
};
